import { render } from "./SelectRichText.vue?vue&type=template&id=18238f0c&scoped=true"
import script from "./SelectRichText.vue?vue&type=script&lang=js"
export * from "./SelectRichText.vue?vue&type=script&lang=js"

import "./SelectRichText.vue?vue&type=style&index=0&id=18238f0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18238f0c"]])

export default __exports__